// extracted by mini-css-extract-plugin
module.exports = {"main":"tools_main__2mLBA","text":"tools_text__cNQd2","list":"tools_list__N5r3p","section":"tools_section__1C-TQ","title":"tools_title__3Own5","innerList":"tools_innerList__1qr0m"};